import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Định dạng tiền VND — CHỈ CON SỐ, không đuôi "₫".
 *
 * ⛳ 12/08/2026 — mục ⑩ tờ 110826[LT]: *"Hiện tại format số đang thể hiện có chữ đ ở cuối số → Bỏ
 * format ….đ"*. Sửa Ở ĐÂY, một chỗ, thay vì đi bóc đuôi ở ~90 tệp đang gọi hàm này — cả hệ đổi
 * cùng lúc thì không màn nào lỡ nhịp, và không ai phải nhớ "màn này đã bỏ chưa".
 *
 * Đuôi "₫" trong NHÃN Ô NHẬP ("Số tiền (₫)") thì GIỮ — đó là lời khai đơn vị cho người đang gõ,
 * không phải cái đuôi lặp lại sau mỗi con số trong bảng. Câu VĂN XUÔI (brief AI, thông báo) cũng
 * giữ "đ" vì ở giữa câu, con số trần dễ đọc nhầm sang số lượng.
 */
export function vnd(n: number) {
  return new Intl.NumberFormat("vi-VN").format(Math.round(n || 0));
}
